<template>
  <!-- 整体居中容器，最大宽度1440px -->
  <div class="app-container">
    <div style="padding: 20px;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
        <h2>
          <span :style="{ color: priceColor, transition: 'color 0.3s', fontSize: '24px' }">
            ETH:{{ ethPrice }}
          </span>
        </h2>
        <el-button size="small" icon="el-icon-switch-button" @click="handleLogout"></el-button>
      </div>

      <div style="margin-bottom: 20px;">
        <el-button-group>
          <el-button  size="small" icon="el-icon-plus" @click="openDialog('create')">新建任务</el-button>
          <el-button  size="small" icon="el-icon-search" @click="toggleOrders">{{ showOrders ? '收起记录' : '任务记录' }}</el-button>
        </el-button-group>
      </div>

      <!-- 激活任务实时信息 -->
      <div v-if="activeOrderInfo" class="active-order-banner">
        <div class="ao-row">
          <el-tag :type="activeOrderInfo.direction === 'buy' ? 'success' : 'danger'" size="small">
            {{ activeOrderInfo.direction === 'buy' ? '做多' : '做空' }}
          </el-tag>
          <span class="ao-label">开仓价</span>
          <span class="ao-value">{{ activeOrderInfo.open_price }}</span>
          <span class="ao-label">当前价</span>
          <span class="ao-value">{{ activeOrderInfo.current_price }}</span>
          <span class="ao-label">数量</span>
          <span class="ao-value">{{ activeOrderInfo.order_size }}</span>
          <span class="ao-label">浮动盈亏</span>
          <span class="ao-value" :style="{ color: activeOrderInfo.floating_profit >= 0 ? '#67C23A' : '#F56C6C', fontWeight: 'bold' }">
            {{ activeOrderInfo.floating_profit >= 0 ? '+' : '' }}{{ activeOrderInfo.floating_profit }}
          </span>
          <span class="ao-label">盈亏比</span>
          <span class="ao-value" :style="{ color: activeOrderInfo.profit_ratio >= 0 ? '#67C23A' : '#F56C6C', fontWeight: 'bold' }">
            {{ (activeOrderInfo.profit_ratio * 100).toFixed(2) }}%
          </span>
        </div>

        <!-- 阶梯锁利信息行 -->
        <div v-if="activeOrderInfo.trailing && activeOrderInfo.trailing.enabled" class="ao-row ao-trailing">
          <!-- <span class="ao-label">阶梯锁利</span> -->
          <span v-for="(step, i) in activeOrderInfo.trailing.steps" :key="i" class="ao-step-tag"
            :class="{
              'step-reached': i <= activeOrderInfo.trailing.active_step_index,
              'step-current': i === activeOrderInfo.trailing.active_step_index,
              'step-pending': i > activeOrderInfo.trailing.active_step_index
            }">
            ROI:{{ (step.roi * 100).toFixed(1) }}%×{{ (step.lock * 100).toFixed(0) }}%
          </span>
          <span class="ao-label">最高盈利</span>
          <span class="ao-value ao-profit-high">{{ (activeOrderInfo.trailing.max_profit_ratio * 100).toFixed(2) }}%</span>
          <span v-if="activeOrderInfo.trailing.active_step_index >= 0" class="ao-label">锁利平仓</span>
          <span v-if="activeOrderInfo.trailing.active_step_index >= 0" class="ao-value ao-trigger-line">
            {{ activeOrderInfo.trailing.lock_price }}
            <span class="ao-trigger-note">({{ (activeOrderInfo.trailing.lock_line * 100).toFixed(2) }}%)</span>
          </span>
        </div>
      </div>

      <!-- 订单记录表 -->
      <div v-if="showOrders" v-loading="ordersLoading" style="margin-bottom: 20px;">
        <el-table :data="orders" border stripe size="small" style="width: 100%;" max-height="400">
          <el-table-column type="index" label="#" width="35" fixed></el-table-column>
          <el-table-column label="方向" width="60">
            <template slot-scope="{ row }">
              <el-tag :type="row.direction === 'buy' ? 'success' : 'danger'" size="mini">
                {{ row.direction === 'buy' ? '买' : '卖' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="open_price" label="开仓价" width="80"></el-table-column>
          <el-table-column prop="close_price" label="平仓价" width="80">
            <template slot-scope="{ row }"> {{ row.close_price || '--' }} </template>
          </el-table-column>
          <el-table-column prop="order_size" label="数量" width="60"></el-table-column>
          <el-table-column label="盈亏" width="90">
            <template slot-scope="{ row }">
              <span v-if="row.profit !== null" :style="{ color: row.profit >= 0 ? '#67C23A' : '#F56C6C', fontWeight: 'bold' }">
                {{ row.profit >= 0 ? '+' : '' }}{{ row.profit }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="开仓时间" width="130">
            <template slot-scope="{ row }"> {{ formatTime(row.open_time) }} </template>
          </el-table-column>
          <el-table-column label="平仓时间" width="130">
            <template slot-scope="{ row }"> {{ row.close_time ? formatTime(row.close_time) : '--' }} </template>
          </el-table-column>
          <el-table-column label="状态" width="70">
            <template slot-scope="{ row }">
              <el-tag :type="row.status === 'open' ? 'warning' : 'info'" size="mini">
                {{ row.status === 'open' ? '持仓' : '已平仓' }}
              </el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" width="60" fixed="right">
            <template slot-scope="{ row }">
              <el-popconfirm title="确定删除该订单？" @confirm="handleDeleteOrder(row.id)">
                <el-button size="mini" type="danger" icon="el-icon-delete" slot="reference" circle></el-button>
              </el-popconfirm>
            </template>
          </el-table-column> -->
        </el-table>
        <div v-if="orders.length === 0" style="text-align: center; padding: 20px; color: #909399;">
          暂无订单记录
        </div>
      </div>

      <!-- 卡片列表容器（订单记录显示时隐藏） -->
      <div v-loading="loading" class="card-container" v-show="!showOrders">
        <div v-if="tasks.length === 0" class="empty-placeholder">
          <i class="el-icon-document"></i>
          <p>暂无任务数据</p>
        </div>

        <el-row :gutter="16" v-else>
          <!-- 响应式栅格：手机2个(xs=12)，电脑4个(lg=6) -->
          <el-col :xs="12" :sm="12" :md="8" :lg="6" v-for="task in tasks" :key="task.id" style="margin-bottom: 16px;">
            <el-card class="task-card" shadow="hover">
              <!-- 卡片头部 -->
              <div slot="header" class="card-header">
                <!--div class="task-id">ID: {{ task.id }}</div-->
                <div class="task-badges">
                  <el-tag :type="task.direction === 'buy' ? 'success' : 'danger'" size="small">
                    {{ task.direction === 'buy' ? '买入' : '卖出' }}
                  </el-tag>
                  <el-tag :type="task.task_id === activeTaskId ? 'warning' : 'info'" size="small" style="margin-left: 8px;">
                    {{ task.task_id === activeTaskId ? 'activated' : task.status }}
                  </el-tag>
                </div>
              </div>

              <!-- 卡片主体内容：固定6行，保证所有卡片高度一致 -->
              <div class="card-content">
                <div class="info-row">
                  <span class="label">触发价：</span>
                  <span class="value">{{ task.trigger_price }}</span>
                </div>
                <div class="info-row">
                  <span class="label">下单量：</span>
                  <span class="value">{{ task.order_size }}</span>
                </div>
                <div class="info-row">
                  <span class="label">固定止盈：</span>
                  <span class="value">{{ task.take_profit ? task.take_profit : '--' }}</span>
                </div>
                <div class="info-row">
                  <span class="label">固定止损：</span>
                  <span class="value">{{ task.stop_loss ? task.stop_loss : '--' }}</span>
                </div>
                <div class="info-row">
                  <span class="label">执行次数：</span>
                  <span class="value">{{ task.total_times ? task.total_times : '--' }} 次</span>
                </div>
                <div class="info-row">
                  <span class="label">阶梯锁利：</span>
                  <span class="value">
                    <el-tag :type="task.trailing_profit_enabled ? 'success' : 'info'" size="mini">
                      {{ task.trailing_profit_enabled ? '已启用' : '未启用' }}
                    </el-tag>
                  </span>
                </div>
              </div>

              <!-- 卡片底部操作按钮 -->
              <div class="card-actions">
                <el-button size="small" type="primary" plain @click="openDialog('edit', task)">编辑</el-button>
                <el-popconfirm title="确定删除该任务吗？" @confirm="handleDelete(task.task_id)">
                  <el-button size="small" type="danger" plain slot="reference">删除</el-button>
                </el-popconfirm>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <!-- 对话框（手机端自适应宽度） -->
      <el-dialog :title="dialogType === 'create' ? '新建任务' : '编辑任务'" :visible.sync="dialogVisible" :width="dialogWidth">
        <el-form :model="form" label-width="100px">
          <el-form-item label="方向">
            <el-radio-group v-model="form.direction">
              <el-radio label="buy">买入</el-radio>
              <el-radio label="sell">卖出</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="触发价格">
            <el-input-number v-model="form.trigger_price" :min="500" :precision="1" :step="1"
              style="width: 100%"></el-input-number>
          </el-form-item>

          <el-form-item label="下单数量">
            <el-input-number v-model="form.order_size" :precision="1" :min="0.1" :step="0.1"
              style="width: 100%"></el-input-number>
          </el-form-item>

          <el-form-item label="总执行次数">
            <el-input-number v-model="form.total_times" :min="1" :step="1" style="width: 100%"></el-input-number>
          </el-form-item>

          <el-form-item label="固定止盈价">
            <el-input-number v-model="form.take_profit" :precision="2" :min="1" :step="1"
              style="width: 100%"></el-input-number>
          </el-form-item>

          <el-form-item label="固定止损价">
            <el-input-number v-model="form.stop_loss" :precision="2" :min="1" :step="1"
              style="width: 100%"></el-input-number>
          </el-form-item>

          <el-divider></el-divider>

          <el-form-item label="阶梯锁利">
            <el-switch v-model="form.trailing_profit_enabled" :active-value="1" :inactive-value="0"></el-switch>
          </el-form-item>

          <el-form-item v-if="form.trailing_profit_enabled" label="锁利配置">
            <div v-for="(step, index) in form.profit_steps" :key="index" style="margin-bottom: 8px;">
              
              <el-input-number v-model="step.roi" :precision="2" :min="0.2" :step="0.1" size="mini" style="width: 95px"
                placeholder="ROI倍数"></el-input-number>
              -
              <el-input-number v-model="step.lock" :precision="2" :min="0" :step="0.1" size="mini" style="width: 95px"
                placeholder="锁利比例"></el-input-number>
              <el-button type="text" @click="form.profit_steps.splice(index, 1)" size="mini"
                style="color: #F56C6C; margin-left: 5px;">删除</el-button>
            </div>
            <el-button type="text" @click="form.profit_steps.push({ roi: 0, lock: 0 })" icon="el-icon-plus"
              size="mini">添加阶梯</el-button>
          </el-form-item>
        </el-form>

        <div slot="footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { http, WS_URL } from '../api/cloudflare';
const API_TASKS = '/tasks';

export default {
  data() {
    return {
      ethPrice: '连接中...',
      lastPrice: 0,
      priceColor: '#409EFF',
      intentionallyClosed: false,
      reconnectTimer: null,
      destroyedComp: false,
      tasks: [],
      loading: false,
      dialogVisible: false,
      dialogWidth: window.innerWidth < 768 ? '92%' : '500px',
      dialogType: 'create',
      form: {
        task_id: null,
        direction: 'buy',
        trigger_price: 0,
        order_size: 0,
        total_times: 1,
        take_profit: 0,
        stop_loss: 0,
        trailing_profit_enabled: 0,
        profit_steps: []
      },
      // 订单记录
      showOrders: false,
      orders: [],
      ordersLoading: false,
      // 激活任务实时信息
      activeOrderInfo: null,
      activeTaskId: null
    };
  },

  // 路由离开 → 彻底关闭 WS
  beforeRouteLeave(to, from, next) {
    this.intentionallyClosed = true;
    this.clearReconnectTimer();
    this.closeWebSocket();
    next();
  },

  created() {
    // 最严格判断：没有 token 直接不运行任何逻辑
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }

    this.fetchTasks();
    this.initWebSocket();
  },

  beforeDestroy() {
    this.destroyedComp = true;
    this.intentionallyClosed = true;
    this.clearReconnectTimer();
    this.closeWebSocket();
  },

  methods: {
    clearReconnectTimer() {
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }
    },

    // 彻底关闭 WS，不留任何监听
    closeWebSocket() {
      if (this.ws) {
        try {
          this.ws.onclose = null;
          this.ws.onmessage = null;
          this.ws.onerror = null;
          this.ws.onopen = null;
          this.ws.close();
        } catch (e) {e}
        this.ws = null;
      }
    },

    initWebSocket() {
      // 只要以下任意一个成立 → 绝对不连 WS
      if (
        this.destroyedComp ||
        this.intentionallyClosed ||
        !localStorage.getItem('token')
      ) {
        return;
      }

      const token = localStorage.getItem('token');
      this.ws = new WebSocket(WS_URL + '?token=' + token);

      this.ws.onopen = () => {
        this.ethPrice = '已连接，等待数据...';
      };

      this.ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.type === 'price') {
            const newPrice = data.price;
            this.priceColor = newPrice < this.lastPrice ? '#F56C6C' : '#409EFF';
            this.lastPrice = newPrice;
            this.ethPrice = newPrice.toFixed(2);
          } else if (data.type === 'active_order') {
            if (data.active) {
              this.activeOrderInfo = data;
              this.activeTaskId = data.task_id || null;
              // 实时更新 tasks 中对应任务的 status 为 activated（无需刷新页面）
              const task = this.tasks.find(t => t.task_id === data.task_id);
              if (task) {
                task.status = 'activated';
              }
            } else {
              this.activeOrderInfo = null;
              this.activeTaskId = null;
              // 订单关闭时重新拉取任务列表，获取最新 status
              this.fetchTasks();
            }
          }
        } catch (e) {e}
      };

      this.ws.onerror = (err) => {
        this.ethPrice = '连接错误';
        err
      };

      // 核心修复：只要没 token，绝对不重连
      this.ws.onclose = () => {
        this.ws = null;

        if (
          this.intentionallyClosed ||
          this.destroyedComp ||
          !localStorage.getItem('token')
        ) {
          return;
        }

        // 3秒重连
        this.reconnectTimer = setTimeout(() => {
          this.initWebSocket();
        }, 3000);
      };
    },

    async fetchTasks() {
      this.loading = true;
      try {
        const res = await http.get(API_TASKS);
        this.tasks = res.data || [];
      } catch (e) {
        this.$message.error('获取列表失败');
      } finally {
        this.loading = false;
      }
    },

    openDialog(type, row) {
      this.dialogType = type;
      this.dialogVisible = true;
      if (type === 'edit') {
        this.form = { ...row, profit_steps: row.profit_steps || [] };
      } else {
        this.form = {
          task_id: null,
          direction: 'buy',
          trigger_price: 0,
          order_size: 0,
          total_times: 1,
          take_profit: 0,
          stop_loss: 0,
          trailing_profit_enabled: 0,
          profit_steps: []
        };
      }
    },

    async submitForm() {
      try {
        if (this.dialogType === 'create') {
          const res = await http.post(API_TASKS, this.form);
          const taskId = res.data.task_id;
          if (this.form.trailing_profit_enabled && this.form.profit_steps.length) {
            for (const s of this.form.profit_steps) {
              await http.post(`${API_TASKS}/${taskId}/profit-steps`, { roi: s.roi, lock: s.lock });
            }
          }
        } else {
          // 编辑：先更新任务本身
          await http.put(`${API_TASKS}/${this.form.task_id}`, this.form);

          // 再同步锁利配置：先删旧配置，再插入新配置
          const taskId = this.form.task_id;
          const oldStepsRes = await http.get(`${API_TASKS}/${taskId}/profit-steps`);
          const oldSteps = oldStepsRes.data || [];
          for (const step of oldSteps) {
            await http.delete(`${API_TASKS}/${taskId}/profit-steps/${step.id}`);
          }
          // 插入新配置
          if (this.form.trailing_profit_enabled && this.form.profit_steps.length) {
            for (const s of this.form.profit_steps) {
              await http.post(`${API_TASKS}/${taskId}/profit-steps`, { roi: s.roi, lock: s.lock });
            }
          }
        }
        this.dialogVisible = false;
        this.fetchTasks();
        this.$message.success('保存成功');
      } catch (e) {
        this.$message.error('操作失败');
      }
    },

    async handleDelete(taskId) {
      try {
        await http.delete(`${API_TASKS}/${taskId}`);
        this.fetchTasks();
        this.$message.success('删除成功');
      } catch (e) {
        this.$message.error('删除失败');
      }
    },

    // ─── 订单记录方法 ─────────────────────────────────────────────
    toggleOrders() {
      this.showOrders = !this.showOrders;
      if (this.showOrders) {
        this.fetchOrders();
      }
    },

    async fetchOrders() {
      this.ordersLoading = true;
      try {
        const res = await http.get('/orders');
        this.orders = res.data || [];
      } catch (e) {
        this.$message.error('获取订单记录失败');
      } finally {
        this.ordersLoading = false;
      }
    },

    async handleDeleteOrder(id) {
      try {
        await http.delete(`/orders/${id}`);
        this.$message.success('删除成功');
        this.fetchOrders();
      } catch (e) {
        this.$message.error('删除失败');
      }
    },

    formatTime(timeStr) {
      if (!timeStr) return '--';
      // "2026-06-18 21:11:36" → "6-18 21:11:36"
      const match = timeStr.match(/^\d{4}-(\d{2})-(\d{2}) (.+)$/);
      if (match) {
        const m = parseInt(match[1], 10);
        const d = parseInt(match[2], 10);
        return `${m}-${d} ${match[3]}`;
      }
      return timeStr;
    },

    handleLogout() {
      // 退出时 100% 清理
      this.intentionallyClosed = true;
      this.clearReconnectTimer();
      this.closeWebSocket();
      
      localStorage.removeItem('token');
      this.$router.push('/login');
    }
  }
};
</script>


<style scoped>
/* 整体页面最大宽度1440px，左右居中 */
.app-container {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.card-container {
  min-height: 400px;
}

.empty-placeholder {
  text-align: center;
  padding: 60px 0;
  color: #909399;
}

.empty-placeholder i {
  font-size: 48px;
  margin-bottom: 16px;
  display: block;
}

.empty-placeholder p {
  font-size: 14px;
  margin: 0;
}

.task-card {
  transition: box-shadow 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 移除鼠标悬停时的位移效果，仅保留阴影变化 */
.task-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: none;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  flex-wrap: wrap;
  gap: 8px;
}

.task-id {
  font-size: 14px;
  color: #606266;
}

.task-badges {
  display: flex;
  align-items: center;
}

.card-content {
  flex: 1;
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* 统一行间距，使高度一致 */
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  line-height: 1.4;
}

.info-row .label {
  color: #909399;
  font-weight: normal;
}

.info-row .value {
  color: #303133;
  font-weight: 500;
}

.card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 12px;
  border-top: 1px solid #EBEEF5;
  margin-top: 8px;
}

/* 激活任务实时信息横幅 */
.active-order-banner {
  background: #F0F9FF;
  border: 1px solid #B3D8FF;
  border-left: 4px solid #409EFF;
  border-radius: 6px;
  padding: 10px 16px;
  margin-bottom: 16px;
}

.active-order-banner .ao-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 16px;
}

.ao-label {
  color: #606266;
  font-size: 13px;
}

.ao-value {
  color: #303133;
  font-size: 14px;
  font-weight: 500;
}

/* 阶梯锁利样式 */
.ao-trailing {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #B3D8FF;
}

.ao-step-tag {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 3px;
  font-size: 11px;
  margin-right: 4px;
  border: 1px solid #DCDFE6;
}

.ao-step-tag.step-reached {
  background: #E1F3D8;
  border-color: #67C23A;
  color: #67C23A;
}

.ao-step-tag.step-current {
  background: #FAECD8;
  border-color: #E6A23C;
  color: #E6A23C;
  animation: step-blink 1s infinite;
}

.ao-step-tag.step-pending {
  background: #F5F7FA;
  border-color: #DCDFE6;
  color: #C0C4CC;
}

@keyframes step-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

.ao-profit-high {
  color: #67C23A;
  font-weight: bold;
}

.ao-trigger-line {
  color: #E6A23C;
  font-weight: bold;
}

.ao-next-trigger {
  color: #909399;
  font-weight: 500;
}

.ao-next-note {
  color: #909399;
  font-size: 12px;
  font-weight: normal;
}

.ao-trigger-note {
  color: #909399;
  font-size: 12px;
  font-weight: normal;
}

/* 手机端适配：减小字体和内边距，保持卡片高度一致 */
/* 手机端适配：减小字体和内边距，保持卡片高度一致 */
@media (max-width: 768px) {
  .info-row {
    font-size: 12px;
  }

  .card-actions .el-button {
    padding: 6px 12px;
    font-size: 12px;
  }

  .card-header {
    font-size: 12px;
  }

  .task-id {
    font-size: 12px;
  }

  .card-content {
    gap: 10px;
  }

  /* 手机端对话框自适应 */
  .el-dialog {
    margin-top: 5vh !important;
  }
  .el-dialog__body {
    padding: 15px 10px;
  }
}
</style>